import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { formatCategoryList } from 'src/app/components/admin/category/category-helpers';
import { CategoryBasicView } from 'src/app/swagger-api';

@Pipe({ name: 'formatCategories' })
export class FormatCategoriesPipe implements PipeTransform {
  private translateService = inject(TranslateService);

  private defaultEmptyHint = 'DISEASES_SPECIALTIES_LIST_NOT_SPECIFIED_HINT';

  public transform(categories: CategoryBasicView[], showEmptyHint = true): string {
    const displayString = formatCategoryList(categories);

    if (showEmptyHint && displayString === '') {
      return this.translateService.instant(this.defaultEmptyHint) as string;
    }

    return displayString;
  }
}
